import './App.css';
import react from 'react';
import Navbar from './components/Navbar';
import Content from './components/Content';


function App() {
  return (
    <>
    
      <Navbar/>
      {/* <Content/> */}
      
    
    </>
  );
}

export default App;
